import { FeatureFlag } from '../FeatureFlag';

export const riskWidgetsShouldShowNewSymbolPicker = new FeatureFlag({
    key: 'risk-widgets-should-show-new-symbol-picker',
    createdOn: '2025-07-07',
    defaultValue: false,
});
